import React, { useState } from "react";
import { Button } from "../ButtonElement";
import {
    HelloContainer,
    HelloBg,
    VideoBg,
    HelloContent,
    HelloH1,
    HelloP,
    HelloBtnWrapper,
    ArrowForward,
    ArrowRight,
} from "./HelloSection";
import Video from "../../videos/first.mp4";

const HelloSection = () => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    };

    return (
        <HelloContainer id="main">
            <HelloBg>
                <VideoBg
                    autoPlay
                    loop
                    muted
                    src={Video}
                    type="video/mp4"
                ></VideoBg>
            </HelloBg>
            <HelloContent>
                <HelloH1>Приветствуем Вас на сайте компании "Мэтр"!</HelloH1>
                <HelloP>
                    Ряд услуг, позволяющих сделать интерьер помещения
                    максимально изысканным, легким и эргономичным. Как
                    специалисты мы всегда действуем в ваших интересах.
                    Ознакомьтесь со списком наших услуг.
                </HelloP>
                <HelloBtnWrapper>
                    <Button
                        to="gallery"
                        dark="true"
                        primary="true"
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-160}
                        onMouseEnter={onHover}
                        onMouseLeave={onHover}
                    >
                        Примеры работ{" "}
                        {hover ? <ArrowForward /> : <ArrowRight />}
                    </Button>
                </HelloBtnWrapper>
            </HelloContent>
        </HelloContainer>
    );
};

export default HelloSection;
